<template>
  <v-navigation-drawer
    :model-value="data.getShowCountersPanel"
    location="right"
    :scrim="false"
    :style="{ width: width, 'max-width': '50%' }"
    temporary
  >
    <OperationalComponent
      type="counter"
      icon="data_thresholding"
      :title="$t('countersAlarm')"
      :closeDialog="closeDialog"
      :acceptEnabled="false"
    >
    <v-row>
        <v-col class="text-subtitle-2" cols="3">Name</v-col>
        <v-col class="d-flex align-center">
          <span style="white-space: nowrap; overflow: hidden; max-width: 300px" data-qa="device-name">
          {{ name }}
          </span>
        </v-col>
      </v-row>
    <div class="operational custom-scrollbars">
      <v-layout class="flex-column h-100">
        <div
          class="slot-div"
          style="
            height: 100%;
            position: relative;
            top: 0px;
            overflow: auto;
          "
        >
        <VueFlow class="vueflow-counter">
          <Background :variant="BackgroundVariant.Lines" />

          <template #node-custom="{ data }">
            <CustomNode :data="data" />
          </template>
        </VueFlow>
        </div>
      </v-layout>
    </div>
    </OperationalComponent>
  </v-navigation-drawer>
  <AlarmHistoryCounters ref="CountersHistoryTable" :view="view" :alarmId="alarmId" :transitionId="transitionId" :label="label"></AlarmHistoryCounters>
</template>

<script setup>
import { ref, watch } from 'vue';
import { VueFlow, useVueFlow } from '@vue-flow/core'
import { Background, BackgroundVariant } from '@vue-flow/background'
import { dataStore } from '../stores/data'
import { useDisplay } from 'vuetify'
import OperationalComponent from "./UIComponents/OperationalComponent.vue";
import AlarmHistoryCounters from "./AlarmHistoryCounters.vue";
import CustomNode from './AdvancedAlarm/CustomNode.vue';
import { alarmTemplates } from './AdvancedAlarm/advancedAlarmTemplate';

const data = dataStore();

const nameDisplay = useDisplay().name;

let vueInstance;

const width = ref("0px");
const type = ref({id: "ON_OFF"});
let name = ref("")
let transitions = ref([]);
let alarmId = ref("");
let transitionId = ref("");
let label = ref("");
let view = ref(false);

const { setNodes, setEdges, onEdgeClick, nodesDraggable, panOnDrag, onPaneReady } = useVueFlow({
  zoomOnScroll: false, 
  zoomOnPinch: false,
  zoomOnDoubleClick: false,
  panOnScroll: false,
  preventScrolling: false,
})

onPaneReady((instance) => {
  vueInstance = instance;
})

onEdgeClick((event) => {
  const isSameEdge = view.value && transitionId.value === event.edge.transitionId;
  if (isSameEdge) {
    // Panel is open and the same edge was clicked: close and clear selection
    view.value = false;
    transitionId.value = "";
    label.value = "";
    return;
  }
  // Panel is closed or a different edge was clicked: open/update with the clicked edge's transition
  label.value = event.edge.label;
  transitionId.value = event.edge.transitionId;
  view.value = true;
})

const closeDialog = (event) => {
  data.closeCounters(event)
}

function refreshStateMachine() {
  if (data.getShowCountersPanel) {
      setNodes(alarmTemplates[type.value.id].nodes);
      setEdges(alarmTemplates[type.value.id].edges.map(e => {
        const source = alarmTemplates[type.value.id].nodes.find(n => n.id === e.source);
        const target = alarmTemplates[type.value.id].nodes.find(n => n.id === e.target);
        let counter = 0;
        const transition = transitions.value.find(t => {
          if (source.class === 'alarm-node-initial' && t.fromState != 'initial') {
            return false
          }
          if (target.class === 'alarm-node-final' && !t.final) {
            return false
          }
          if (source.class != 'alarm-node-initial' && source.label.replace(" - ", " ") != t.fromState.replace(" - ", " ")) {
            return false
          }
          if (target.class != 'alarm-node-final' && target.label.replace(" - ", " ") != t.toState.replace(" - ", " ")) {
            return false
          } 
          if (t.counter) counter = t.counter;
          return true;
        })
        return {
          ...e, 
          label: e.label + ' ('+counter+')', 
          transitionId: transition.transitionId, 
          labelStyle: { pointerEvents: 'all', cursor: 'pointer', fill: 'var(--color-highlight)', 'text-decoration': 'underline' } };
      }));
      nodesDraggable.value = false;
      panOnDrag.value = false;
    }
}

watch(() => data.getShowCountersPanel, async (newVal) => {
  if (newVal) {
    const alarm = await data.fetchTransitions(data.counterAlarmId);
    name.value = alarm.name;
    alarmId.value = alarm.alarmId;
    transitions.value = alarm.transitions;
    type.value = { id: alarm.type };
    let zoom = 1;
    switch (nameDisplay.value) {
      case "xs":
        zoom = 0.6;
        width.value = "100%";
      case "sm":
        zoom = 0.6;
        width.value = "50%";
      case 'md': 
        zoom = 0.8;
        width.value = "50%";
      default:
        width.value = "600px";
    }
    vueInstance.setViewport({ x: 0, y: 0, zoom });
    refreshStateMachine()
  } else {
    view.value = false;
    width.value = "0px";
  }
});
</script>

<style>
.vue-flow__node {
  cursor: default !important;
}

.vueflow-counter .vue-flow__edge-text:hover {
  fill:var(--color-highlight);
  text-decoration:none !important;
}
</style>